export const getDisplayName = (profile = {}, fallback = "") => {
  const firstName = profile?.first_name || profile?.firstName || "";
  const lastName = profile?.last_name || profile?.lastName || "";
  const fullName = `${firstName} ${lastName}`.trim();

  return fullName || profile?.user_name || profile?.email || fallback;
};

export const normalizePetOwner = (owner = {}) => {
  const profile = owner.profile || {};

  return {
    ...owner,
    profile,
    first_name: owner.first_name || profile.first_name || "",
    last_name: owner.last_name || profile.last_name || "",
    email: owner.email || profile.email || "",
    phone: owner.phone || profile.phone || "",
    alt_phone: owner.alt_phone || profile.alt_phone || "",
    city_name: owner.city_name || profile.city_name || "",
    state_name: owner.state_name || profile.state_name || "",
    country: owner.country || profile.country || "",
    street_address: owner.street_address || profile.street_address || "",
    postal_code: owner.postal_code || profile.postal_code || "",
    profile_image_url: owner.profile_image_url || profile.profile_image_url || "",
    displayName: getDisplayName(profile, `Pet Owner #${owner.id || ""}`),
    pets: Array.isArray(owner.pets) ? owner.pets : [],
  };
};

export const normalizePet = (pet = {}) => {
  const owner = pet.owner ? normalizePetOwner(pet.owner) : null;
  const petTypeName =
    pet.pet_type ||
    pet.pet_types ||
    pet.petType?.pet_type ||
    pet.petType?.type_name ||
    pet.species ||
    "";
  const genderName =
    pet.gender_name ||
    pet.gender?.gender ||
    pet.gender?.gender_name ||
    pet.gender ||
    "";
  const foodTypeName =
    pet.food_type ||
    pet.foodType?.food_type ||
    pet.foodType?.name ||
    "";

  return {
    ...pet,
    owner,
    ownerName: owner?.displayName || "",
    petTypeName,
    species: pet.species || petTypeName || "N/A",
    genderName: genderName || "Unknown",
    foodTypeName: foodTypeName || "N/A",
    displayWeight: pet.weight_kg ?? pet.weight ?? "",
  };
};

export const normalizeInvoice = (invoice = {}) => {
  const items = Array.isArray(invoice.items) ? invoice.items : [];
  const transactions = Array.isArray(invoice.transactions) ? invoice.transactions : [];
  const totalAmount = Number(invoice.total_amount || invoice.amount || 0);
  const paidAmount = transactions.reduce(
    (sum, transaction) => sum + Number(transaction.amount_paid || transaction.amount || 0),
    0
  );

  return {
    ...invoice,
    items,
    transactions,
    invoiceNumber: invoice.invoice_number || `INV-${invoice.id || "NA"}`,
    totalAmount,
    paidAmount,
    balanceAmount: Math.max(totalAmount - paidAmount, 0),
    paymentStatus: invoice.status || "pending",
  };
};
